<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom: 0;">
      <div class="website-top-actions">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-chat-dot-round"
          class="ele-btn-icon"
          @click="showBotCommand = true">机器人命令
        </el-button>
      </div>
      <el-row :gutter="15">
        <el-col :lg="6" style="margin-bottom: 15px;">
          <ele-pro-table
            ref="table"
            :datasource="url"
            :columns="columns"
            height="calc(100vh - 261px)"
            :need-page="false"
            :toolkit="[]"
            :current.sync="current"
            highlight-current-row
            class="param-table"
            tool-class="ele-toolbar-actions"
            @done="done">
            <template slot="toolbar">
              <el-button
                v-if="permission.includes('sys:website:add')"
                size="small"
                type="primary"
                icon="el-icon-plus"
                class="ele-btn-icon"
                @click="openEdit(null)">添加
              </el-button>
              <el-button
                v-if="permission.includes('sys:website:edit')"
                size="small"
                type="warning"
                icon="el-icon-edit"
                class="ele-btn-icon"
                :disabled="!current"
                @click="openEdit(current)">编辑
              </el-button>
              <el-button
                v-if="permission.includes('sys:website:delete')"
                size="small"
                type="danger"
                icon="el-icon-delete"
                class="ele-btn-icon"
                :disabled="!current"
                @click="remove">删除
              </el-button>
            </template>
          </ele-pro-table>
        </el-col>
        <el-col :lg="18" style="margin-bottom: 15px;">
          <param-data v-if="current" :config-id="current.id" />
        </el-col>
      </el-row>
    </el-card>
    <param-edit :visible.sync="showEdit" :data="editData" @done="reload" />
    <bot-command-config :visible.sync="showBotCommand" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ParamData from './param-data';
import ParamEdit from './param-edit';
import BotCommandConfig from './bot-command-config';

export default {
  name: 'ConfigParam',
  components: { ParamData, ParamEdit, BotCommandConfig },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/config/index',
      columns: [
        { columnKey: 'index', type: 'index', label: '序号', width: 55, align: 'center' },
        { prop: 'name', label: '配置名称', showOverflowTooltip: true, minWidth: 100 },
        { prop: 'code', label: '编码', showOverflowTooltip: true, minWidth: 90 }
      ],
      current: null,
      showEdit: false,
      editData: null,
      showBotCommand: false
    };
  },
  methods: {
    done(res) {
      if (res.data && res.data.length > 0) {
        this.$refs.table.setCurrentRow(res.data[0]);
      }
    },
    reload() {
      this.$refs.table.reload();
    },
    openEdit(row) {
      this.editData = row;
      this.showEdit = true;
    },
    remove() {
      this.$confirm('确定要删除选中的配置吗?', '提示', { type: 'warning' }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/config/delete', { id: this.current.id }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.website-top-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}
.param-table ::v-deep .el-table__row {
  cursor: pointer;
}
</style>
